import { render, staticRenderFns } from "./FeaturedMembershipBlock.vue?vue&type=template&id=29211a55&"
import script from "./FeaturedMembershipBlock.vue?vue&type=script&lang=js&"
export * from "./FeaturedMembershipBlock.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports